<template>
  <div class="list">
    <div style="display:flex;padding: 10px">
      <el-button type="primary" @click="Back">返 回</el-button>
      <el-button style="float:right" type="primary" @click="openShow()">查看学员往期记录</el-button>
      <el-button style="float:right" type="primary"
                 v-on:click="bookDataisn">导出学员读书
      </el-button>
      <h2 style="margin-left:250px">
        学员读书
      </h2>
      <h2 style="margin-left:640px">
        学员考试
      </h2>
    </div>
    <div style="display:flex;width:100%">
      <el-card style="width:50%;display: block;" >
        <el-table
          id="pdfDom2"
          :data="bookData"
          :max-height="tableExport ? 570:480">
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center">
            <template slot-scope="scope">
              <span>{{ (page - 1) * size + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="400"
            prop="file_name"
            label="文件名">
          </el-table-column>
          <el-table-column
            label="观看页数">
            <template slot-scope="scope">
              <div>
                {{ getPageCount(scope.row.index) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="是否完成">
            <template slot-scope="scope">
              <div>
                {{ getsituation(scope.row) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagediv">
          <el-pagination
            background
            layout="prev, pager, next, total, jumper"
            :total="total"
            :current-page="page"
            :page-size="size"
            @current-change="pagechange">
          </el-pagination>
        </div>
      </el-card>
      <!-- 考试记录-->
      <el-card style="width:50%;display: block">
        <el-table
          :data="testData"
          max-height="480">
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center">
            <template slot-scope="scope">
              <span>{{ (page2 - 1) * size + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="考试时间">
          </el-table-column>
          <el-table-column
            prop="namess"
            label="考卷名">
          </el-table-column>
          <el-table-column
            prop="scores"
            label="总分">
          </el-table-column>
          <el-table-column
            label="得分">
            <template slot-scope="scope">
              {{ scope.row.total }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button type="primary" @click="paperlist(scope.row)">详情</el-button>
              <!-- <el-button type="danger" @click="paperlist2(scope.row)">批改</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagediv">
          <el-pagination
            background
            layout="prev, pager, next, total, jumper"
            :total="total2"
            :current-page="page2"
            :page-size="size"
            @current-change="pagechange2">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 考试情况 -->
    <div>
      <el-dialog
        title="考试情况"
        :visible.sync="dialog">
        <el-button style="position: absolute;right: 0;margin-right: 15px" type="primary"
                   @click="printTable">导出
        </el-button>
        <div>
          <div style="overflow-y:auto" id="pdfDom">
            <div style="display: flex">
              <el-col :span="5">
                <h2>姓名 {{ dataList.name }} </h2>
              </el-col>
              <el-col :span="6">
                <h2 style="margin-left: 15px">得分：{{ totals }}</h2>
              </el-col>
              <el-col :span="12"><h2>职务:{{ jobTitle }}</h2></el-col>
              <el-col :span="15">
                <h2>考试时间: {{ currentData.time }}</h2>
              </el-col>
            </div>
            <h3 v-show="resultList.one.length">判断题</h3>
            <div style="margin:5px" v-for="(item, index) in resultList.one" :key="'likef' + index">
              <div class="exam_topic">
                <div class="topic_name">{{ perfixTopic(item.topic, index) }}({{ item.scores }}分)</div>
                <div style="display:flex">
                  <div>学生答案:{{ trueOrFalse(item.study) }}</div>
                  <div style="width: 2rem"></div>
                  <div>正确答案:{{ change2(item.answer) }}</div>
                  <div style="width: 2rem"></div>
                  <div style="color: green" v-show="!olds" v-if="trueOrFalse(item.study) === item.answer"><i
                    class="el-icon-check"></i>
                  </div>
                  <div style="color: red" v-show="!olds" v-if="trueOrFalse(item.study) !== item.answer"><i
                    class="el-icon-close"></i>
                  </div>
                </div>
              </div>
            </div>
            <h3 v-show="resultList.two.length">选择题</h3>
            <div style="margin:5px" v-for="(item, index) in resultList.two" :key="'like' + index">
              <div class="exam_topic">
                <div class="topic_name">{{ perfixTopic(item.topic, index) }} {{ item.option }} ({{ item.scores }}分)</div>
                <div style="display:flex">
                  <div>学生答案:{{ item.study == -1 ? ' 未答题' : item.study }}</div>
                  <div style="width: 2rem"></div>
                  <div>正确答案:{{ item.answer }}</div>
                  <div style="width: 2rem"></div>
                  <div style="color: green" v-show="!olds" v-if="item.study === item.answer"><i
                    class="el-icon-check"></i></div>
                  <div style="color: red" v-show="!olds" v-if="item.study !== item.answer"><i class="el-icon-close"></i>
                  </div>
                </div>
              </div>
            </div>
            <h3 v-show="resultList.three.length">多选题</h3>
            <div style="margin:5px" v-for="(item, index) in resultList.three" :key="'lik' + index">
              <div class="exam_topic">
                <div class="topic_name">{{ perfixTopic(item.topic, index) }}{{ item.option }}  ({{ item.scores }}分)</div>
                <div style="display:flex">
                  <div>学生答案:{{ item.study == -1 ? ' 未答题' : item.study }}</div>
                  <div style="width: 2rem"></div>
                  <div>正确答案:{{ item.answer }}</div>
                  <div style="width: 2rem"></div>
                  <div style="color: green" v-show="!olds" v-if="Questions(item.study, item.answer)"><i
                    class="el-icon-check"></i>
                  </div>
                  <div style="color: red" v-show="!olds" v-if="!Questions(item.study, item.answer)"><i
                    class="el-icon-close"></i></div>
                </div>
              </div>
            </div>

            <h3 v-show="resultList.for.length">简答题</h3>
            <div style="margin:5px" v-for="(item, index) in resultList.for" :key="'li' + index">
              <div class="exam_topic">
                <div class="topic_name">{{ perfixTopic(item.topic, index) }}({{ item.scores }}分)</div>
                <div style="margin:5px">
                  <div>学生答案:{{ item.study === -1 ? ' 未答题' : item.study }}</div>
                  <div style="width: 2rem"></div>
                  <!-- <div v-if="type === 1">得分:<span style="width: 6rem">{{item.subjectiveTotal}}分数</span></div>
                 <div v-if="type === 0">评分:<el-input v-model="item.subjectiveTotal" onkeyup="value=value.replace(/[^\d]/g,'')" style="width: 6rem">分数</el-input></div> -->
                </div>
              </div>
            </div>
            <!--          <h3 v-if="testCard3">问答题</h3>-->
            <!--          <div style="margin:5px" v-for="(item, $index) in testCard[3]" :key="$index">-->
            <!--            <div class="exam_topic">-->
            <!--              <div class="topic_name">{{$index + 1}}: {{item.exam}}({{item.scores}}分)</div>-->
            <!--              <div style="margin:5px">-->
            <!--                <div>学生答案:{{item.study}}</div>-->
            <!--                <div style="width: 2rem"></div>-->
            <!--                &lt;!&ndash; <div v-if="type === 1">得分:<span style="width: 6rem">{{item.subjectiveTotal}}分数</span></div>-->
            <!--                <div v-if="type === 0">评分:<el-input v-model="item.subjectiveTotal" onkeyup="value=value.replace(/[^\d]/g,'')" style="width: 6rem">分数</el-input></div> &ndash;&gt;-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="onceDialog"
        center>
        <div slot="footer" class="dialog-footer" style="display: block">
          <oncelist :sid="dataList.id"></oncelist>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
import oncelist from '../components/oncelist'

export default {
  components: {
    oncelist
  },
  data () {
    return {
      type: 0,
      test_exam: '',
      testData: [],
      testData2: [],
      file_name: '',
      onceDialog: false,
      total: 0,
      total2: 0,
      totals: 0,
      page: 1,
      page2: 1,
      size: 10,
      olds: true,
      exam: null,
      dataList: window.$global.dataList,
      bookData: [],
      pageData: [],
      pageData2: [],
      testCard: [],
      allData: {
        one: [],
        two: [],
        three: [],
        for: []
      }, // 当前试卷
      examData: [], // 试卷答案
      dialog: false,
      show: 1,
      htmlTitle: '1111',
      study: null,
      currentData: {},
      jobTitle: '',
      tableExport: false
    }
  },
  computed: {
    resultList () { // 选择
      let result = []
      let solution = this.study // 当前试卷答案
      let testPaper = this.allData

      for (let i in testPaper) {
        for (let f in solution) {
          if (i === f) {
            for (let j in testPaper[i]) {
              console.log(testPaper[i][j])
              // let op = solution[f][j].option
              // if (op == undefined || op == null) {
              //   testPaper[i][j].study = -1
              // } else {
              if (solution[f][j] !== undefined) {
                testPaper[i][j].study = solution[f][j].option
              } else {
                testPaper[i][j].study = -1
              }
            }
          }
        }
      }
      for (let i in testPaper.one) {
        testPaper.one[i].answer = this.change2(testPaper.one[i].answer)
      }
      for (let i in testPaper.two) {
        testPaper.two[i].answer = this.change(testPaper.two[i].answer)
      }
      for (let i in testPaper.three) {
        testPaper.three[i].answer = testPaper.three[i].answer.toString()
        if (testPaper.three[i].study.length === 0) {
          testPaper.three[i].study = '未答题'
        }
        testPaper.three[i].study = testPaper.three[i].study.toString()
      }
      result = testPaper
      return result
    }
  },
  mounted () {
    // if (this.global.getBookData.length === 0) {
    this.getBookData()
    // } else {
    //   this.DataPro()
    // }
    this.getGrades()
    this.$nextTick(() => {
      this.jobTitle = this.queryPost(this.dataList)
    })
  },
  methods: {
    getPageCount (page) {
      if (page === 'N/A') {
        return page
      }
      return page + 1 || 0
    },
    bookDataisn () {
      if (this.bookData.length === 0) {
        this.$message.warning('没有需要导出的数据')
        return
      }
      this.tableExport = true
      clearTimeout(this)
      setTimeout(() => {
        this.getPdf(this.dataList.name + '-' + this.jobTitle + '学习记录', 'pdfDom2', this)
      }, 5)
    },
    printTable () {
      setTimeout(() => {
        this.getPdf(this.dataList.name, 'pdfDom', null)
      }, 5)
    },
    queryPost (row) {
      let result = ''
      let list = this.global.optionsList
      for (let i in list) {
        if (list[i].value === row.branch_id) {
          result = (list[i].label) + '-'
          let arr = list[i].children
          for (let s in arr) {
            if (arr[s].value === row.station_id) {
              return result.concat(arr[s].label)
            }
          }
        }
      }
      return result
    },
    openShow () {
      this.onceDialog = true
    },
    trueOrFalse (data) {
      if (data === -1) {
        return '未答题'
      }
      if (data === 1) {
        return '对'
      }
      return '错'
    },
    Questions (option, answer) {
      if (option === undefined || answer === undefined) {
        return
      }
      let start = true
      if (option.length !== answer.length) {
        return false
      }
      for (let i in answer) {
        let options = option.toString()
        if (options.lastIndexOf(answer[i]) === -1) {
          start = false
        }
      }
      return start
    },
    // 获取考试记录
    getGrades () {
      let obj = {}
      obj.data = this.dataList.id
      obj.vm = this
      obj.fn = this.getGradesfn
      req.Post('exam/get_grades', obj)
    },
    // 获取学员考试列表 含答案
    getGradesfn (data) {
      if (data == null) {
        alert('网络连接错误')
        return
      }
      // 原始数据
      this.testData2 = data.examData
      // 通过主观题客观题计算总成绩
      let json = this.testData2
      for (let i in json) {
        // 简答题总分
        // eslint-disable-next-line no-unused-vars
        let shortAnswerScore = 0
        // 拿到简答题
        // eslint-disable-next-line no-unused-vars
        let exam = JSON.parse(json[i].exam)
        // 简答题分数和选择题分数相加
        this.testData2[i].total = json[i].selectTotal + json[i].subjectiveTotal
        // debugger
      }
      this.total2 = data.examData.length
      this.pagechange(this.page)
      this.pagechange2(this.page2)
    },
    getJson (data) {
      let obj = JSON.parse(data)
      let str = ''
      for (let i in obj) {
        str += i + '：' + obj[i] + ' '
      }
      return str
    },
    getPitchOn (row) {
      let selectron = JSON.parse(row.selectron)
      let pitchOn = row.pitchOn
      let obj
      for (let i in selectron) {
        if (pitchOn === selectron[i]) {
          obj = i
          break
        }
      }
      return obj
    },
    getText (row) {
      if (row.list.total) {
        return true
      } else {
        return false
      }
    },
    // 将秒转化为时分
    getTime (endTime) {
      if (endTime === null) {
        return '0 分'
      }
      let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
      let min = 0 // 初始化分
      let h = 0 // 初始化小时
      let result = ''
      if (secondTime > 59) { // 如果秒数大于59，将秒数转换成整数
        min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
        secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
        if (min > 60) { // 如果分钟大于60，将分钟转换成小时
          h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
          min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
        }
      }
      result = `${h.toString().padStart(2, '0')} 小时 ${min.toString().padStart(2, '0')}分`
      return result
    },
    getsituation (data) {
      if (!data || !data.isOver) {
        return '否'
      }
      return '是'
    },
    // 获取suoyou shuben
    getBookData () {
      let now = parseInt(new Date().getTime() / 1000)
      let filter = {}
      let info = this.dataList
      filter.job = info.station_id
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      filter.begin = now
      filter.end = now
      filter.remove = 0
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getBookDataFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    // 获取学习记录回调
    getBookDataFn (data) {
      if (data == null || data.err_code !== 0) {
        // alert(data.err_msg)
        return
      }
      if (!data.list || data.list.length === 0) {
        return
      }
      // this.global.getBookData = JSON.parse(JSON.stringify(data.list))
      let user = this.dataList
      let learnList = data.list
      let list = []
      for (let i in learnList) {
        let learn = learnList[i]
        if (learn.type !== 1) {
          continue
        }
        let job = learn.job
        if (job === 0 && learn.exclude != null) {
          let exclude = learn.exclude
          // debugger
          if (exclude.indexOf(user.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
            continue
          }
        }
        list.push(learn)
      }
      this.global.getBookData = JSON.parse(JSON.stringify(list))
      this.DataPro()
    },
    DataPro () {
      let list = JSON.parse(JSON.stringify(this.global.getBookData))
      // 当前学员已看视频记录
      let played = this.dataList.played
      // 看完视频才会记录
      let video = this.getmustSeeVideo(this.global.video, this.dataList.station_id)
      for (let k in video) {
        let id = video[k].id
        let name = video[k].file_name
        video[k] = {
          'id': id,
          'file_name': name,
          'isOver': false,
          'index': 'N/A',
          'type': 1
        }
        for (let i in played) {
          let num = played[i]
          if (num === id) {
            video[k].isOver = true
          }
        }
        list.push(video[k])
      }
      // 处理已看书本数据
      let listX = this.dataList.study_record
      for (let j in list) { // 所有书本
        for (let i in listX) { // 已经看的书本
          let books = list[j]
          if (Number(i) === Number(books.id)) {
            let lists = listX[i]
            list[j].isOver = lists.isOver
            list[j].index = lists.index
            list[j].type = lists.type
          }
        }
      }
      if (list.length === 0) {
        return
      }
      this.pageData = list
      this.total = list.length
      this.bookData = this.pagefn(list, this.page, this.size)
    },
    pagechange (val) {
      this.page = val
      this.bookData = this.pagefn(this.pageData, this.page, this.size)
    },
    pagechange2 (val) {
      this.page2 = val
      this.testData = this.pagefn(this.testData2, this.page2, this.size)
    },
    pagefn (arr, page, size) {
      let offset = (page - 1) * size
      let info = (offset + size >= arr.length) ? arr.slice(offset, arr.length) : arr.slice(offset, offset + size)
      return info
    },
    Back () {
      this.$router.go(-1)
      this.$parent.$children[0].getData()
    },
    // 试卷详情
    paperlist (row) {
      this.type = 1
      this.getExam(row.exam_id)
      this.dialog = !this.dialog
      let list = JSON.parse(row.exam)
      this.totals = row.selectTotal + row.subjectiveTotal
      this.study = list
      this.currentData = row
      // console.log(this.currentData)
    },
    // 试卷批改
    paperlist2 (row) {
      this.type = 0
      this.getExam(row.exam_id)
      this.dialog = !this.dialog
      let list = JSON.parse(row.exam)
      this.totals = row.selectTotal + row.subjectiveTotal
      this.study = list
    },
    getExam (e) {
      let sendData = {}
      sendData.data = e
      sendData.fn = this.getExamfn
      sendData.vm = this
      req.Post('exam/idGetexam', sendData)
    },
    // 获取必学书本
    getUnreadByType (type) {
      let learnStr = this.user_info
      let learnObj = this.stringToJson(learnStr.study_record)
      let learnList = this.learnList
      let list = []
      for (let i in learnList) {
        let learn = learnList[i]
        let id = learn.id
        if (learn.type !== type) {
          continue
        }
        let job = learn.job
        if (job === 0 && learn.exclude != null) {
          let exclude = learn.exclude
          if (exclude.indexOf(learnStr.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
            continue
          }
        }
        let data = learnObj[id]
        if (data) {
          if (data.isOver) {
            continue
          }
        }
        list.push(learn)
      }
      this.basicsUnread = list
      return list
    },
    // 获取当前学员必看视频
    getmustSeeVideo (arr, id) {
      // debugger
      let video = []
      for (let i in arr) {
        let bol = false
        // debugger
        for (let k in arr[i].job) {
          if (arr[i].job[k] === id) {
            bol = true
            break
          }
        }
        if (bol) {
          video.push(arr[i])
        }
      }
      return video
    },
    judgeIsJson (str) {
      try {
        let value = JSON.parse(str)
        console.log(value)
        return true
      } catch (e) {
        return false
      }
    },
    oldPaper (data) {
      let result = {}
      result.one = []
      result.two = []
      result.three = []
      result.for = []
      for (let item in data) {
        for (let s in data[item]) {
          switch (data[item][s].type) {
            case 1:
              let obj = {}
              obj.answer = data[item][s].answer
              obj.topic = data[item][s].exam
              obj.scores = data[item][s].scores
              obj.option = data[item][s].examOption == null ? -1 : data[item][s].examOption == null
              result.one.push(obj)
              break
            case 2:
              let obj2 = {}
              obj2.answer = data[item][s].answer
              obj2.topic = data[item][s].exam
              obj2.scores = data[item][s].scores
              obj.option = data[item][s].examOption == null ? -1 : data[item][s].examOption == null
              result.two.push(obj2)
              break
            case 3:
              let obj3 = {}
              obj3.answer = data[item][s].answer == null ? -1 : data[item][s].answer == null
              obj3.topic = data[item][s].exam
              obj3.scores = data[item][s].scores
              obj3.option = data[item][s].examOption == null ? -1 : data[item][s].examOption == null
              result.three.push(obj3)
              break
            case 5:
              let obj5 = {}
              obj5.answer = data[item][s].answer
              obj5.topic = data[item][s].exam
              obj5.scores = data[item][s].scores
              obj.option = data[item][s].examOption == null ? -1 : data[item][s].examOption == null
              result.for.push(obj5)
              break
          }
        }
      }
      return result
    },
    // 处理题目开头是否有序号
    perfixTopic (topic, index) {
      let value = topic.trim()
      if (parseFloat(value.substring(0, 1)).toString() === 'NaN') {
        value = (index + 1) + '、' + value
      }
      return value
    },
    // 获取整张试卷  原先 随机抽取题目
    getExamfn (data) {
      if (data == null || data.err_code !== 0) {
        return
      }
      let info = data.examData[0]

      let obj = info.title
      let value = {}
      if (this.judgeIsJson(obj)) {
        this.olds = false
        value = JSON.parse(obj)
      } else if (this.judgeIsJson(obj)) {
        this.olds = true
      } else {
        return
      }
      this.allData.one = value.one
      this.allData.two = value.two
      this.allData.three = value.three
      this.allData.for = value.for
      // // 把题目答案绑定题目
      // let nam = -1
      // for (let k in this.testCard[0]) {
      //   nam = nam + 1
      //   this.testCard[0][k].study = this.study[nam]
      // }
      // for (let k in this.testCard[1]) {
      //   nam = nam + 1
      //   this.testCard[1][k].study = this.study[nam]
      // }
      // for (let k in this.testCard[2]) {
      //   nam = nam + 1
      //   this.testCard[2][k].study = this.study[nam]
      // }
      // for (let k in this.testCard[3]) {
      //   nam = nam + 1
      //   this.testCard[3][k].study = this.study[nam]
      // }
      // for (let k in this.testCard[4]) {
      //   nam = nam + 1
      //   this.testCard[4][k].study = this.study[nam]
      // }
      // // 把下标转换为英文
      // for (let i in this.testCard[0]) {
      //   this.testCard[0][i].study = this.change(this.testCard[0][i].study)
      //   this.testCard[0][i].answer = this.change(this.testCard[0][i].answer)
      // }
      // console.log(this.testCard[1])
      // for (let i in this.testCard[1]) {
      //   this.testCard[1][i].study = this.change2(this.testCard[1][i].study)
      //   this.testCard[1][i].answer = this.change2(this.testCard[1][i].answer)
      // }
      // for (let i in this.testCard[4]) {
      //   let arr = []
      //   for (let j in this.testCard[4][i].study) {
      //     if (this.testCard[4][i].study[j] !== undefined) {
      //       this.testCard[4][i].study[j] = this.change(this.testCard[4][i].study[j])
      //     }
      //   }
      //   for (let j in JSON.parse(this.testCard[4][i].answer)) {
      //     if (this.testCard[4][i].answer[j] !== undefined) {
      //       arr[j] = this.change(JSON.parse(this.testCard[4][i].answer)[j])
      //     }
      //   }
      //   this.testCard[4][i].answer = JSON.stringify(arr)
      //   this.testCard[4][i].study = JSON.stringify(this.testCard[4][i].study)
      // }
      // this.dialog = !this.dialog
    },
    // 把下标转换为英文
    change (e) {
      if (e === '0' || e === 0) {
        return 'A'
      }
      if (e === '1' || e === 1) {
        return 'B'
      }
      if (e === '2' || e === 2) {
        return 'C'
      }
      if (e === '3' || e === 3) {
        return 'D'
      }
      if (e === '4' || e === 4) {
        return 'E'
      }
      if (e === '5' || e === 5) {
        return 'F'
      }
      return e
    },
    change2 (e) {
      if (e === 0 || e === '0') {
        return '错'
      }
      if (e === 1 || e === '1') {
        return '对'
      }
      return e
    }
  }
}
</script>

<style scoped>
.list {
}

.topic_name {
  font-size: 15px;
}

.select {
  /*padding: 10px;*/
  flex-direction: row;
  flex-wrap: nowrap;
}

.center {
  text-align: center;
}

.pagediv {
  width: 100%;
  display: flex;
  padding: 10px;
  position: relative;
  /*bottom: 80px;*/
  justify-content: center;
  /*right: 150px;*/
}
</style>



// WEBPACK FOOTER //
// src/page/dataList.vue